import { Star } from "lucide-react";

export default function Stars({ value = 0, size = "h-4 w-4", onChange, testid }) {
  return (
    <div data-testid={testid} className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => {
        const on = n <= Math.round(value);
        const icon = <Star className={`${size} ${on ? "fill-amber-400 text-amber-400" : "text-zinc-600"}`} />;
        return onChange ? (
          <button key={n} type="button" data-testid={`${testid}-${n}`} onClick={() => onChange(n)} className="transition-transform hover:scale-110">{icon}</button>
        ) : <span key={n}>{icon}</span>;
      })}
    </div>
  );
}

export function RatingBadge({ rating, testid }) {
  if (!rating?.count) return null;
  return (
    <span data-testid={testid} className="flex items-center gap-1 text-[11px] text-amber-300">
      <Star className="h-3 w-3 fill-amber-400 text-amber-400" /> {rating.avg.toFixed(1)} <span className="text-zinc-500">({rating.count})</span>
    </span>
  );
}
